import { clone_package_month } from '../../utils/clone';
import getCitiesFromPackages from '../../utils/get-cities-from-packages';
import getMonthsFromPackages from '../../utils/get-months-from-packages';
import { createReducer } from './create';

const initialState = {
    is_loading_packages: false,
    has_loaded_packages: false,
    unfiltered_packages_by_month: [],
    packages_by_month: [],
    months: [],
    cities: [],
    show_empty_dates: false,
    best_price: null,
    total_tickets: 0,
    total_ticket_available: 0,
};

export default createReducer(initialState, {
    ['PACKAGES/LOAD']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_packages: true,
        });
    },
    ['PACKAGES/LOAD_FINISHED']: (state, payload) => {
        const cities = getCitiesFromPackages(payload.packages);
        const months = getMonthsFromPackages(payload.packages);
        let total_tickets = 0;
        let total_ticket_available = 0;

        for (let i = 0; i < payload.packages.length; ++i) {
            let data = payload.packages[i].data;
            for (let x = 0; x < data.length; ++x) {
                total_tickets = total_tickets + 1;
            }
        }

        let bestPrice = 0;
        for (let i = 0, l = payload.packages.length, month; i < l; ++i) {
            month = payload.packages[i];
            for (let j = 0, ll = month.data.length; j < ll; ++j) {

                if (month.data[j].available) {
                    total_ticket_available++;
                }

                if (month.data[j].price === 0) {
                    continue;
                }

                bestPrice =
                    bestPrice !== 0
                        ? Math.min(bestPrice, month.data[j].price)
                        : month.data[j].price;
            }
        }

        let packages_unfiltered = JSON.parse(JSON.stringify(payload.packages));
        let packages = [];

        for (let i = 0, l = packages_unfiltered.length; i < l; i++) {
            let month = packages_unfiltered[i];
            let month_filtered = [];
            for (var x = 0, len = month.data.length; x < len; x++) {
                let data = month.data[x];
                if (!payload.show_sold_out) {
                    if (data.available) {
                        month_filtered.push(month.data[x]);
                    }
                } else {
                    month_filtered.push(month.data[x]);
                }
            }
            packages.push({
                month: month.month,
                data: month_filtered,
            });
        }

        return Object.assign({}, state, {
            is_loading_packages: false,
            has_loaded_packages: true,
            total_tickets: total_tickets,
            unfiltered_packages_by_month: payload.packages || [],
            packages_by_month: packages || [],
            show_empty_dates: payload.show_sold_out,
            months: months,
            cities: cities,
            best_price: bestPrice,
            total_ticket_available: total_ticket_available,
        });
    },
    ['PACKAGES/FILTER']: (state, payload) => {
        let show_empty_dates = payload.show_empty_dates;
        if (show_empty_dates === undefined) {
            show_empty_dates = state.show_empty_dates;
        }

        let packages_unfiltered = state.unfiltered_packages_by_month;
        let packages = [];

        for (let i = 0, l = packages_unfiltered.length; i < l; i++) {
            let month = packages_unfiltered[i];
            let month_filtered = [];
            for (var x = 0, len = month.data.length; x < len; x++) {
                let data = month.data[x];
                if (!show_empty_dates) {
                    if (data.available) {
                        month_filtered.push(month.data[x]);
                    }
                } else {
                    month_filtered.push(month.data[x]);
                }
            }
            packages.push({
                month: month.month,
                data: month_filtered,
            });
        }

        let filteredPackages;

        let month_filter = state.month_filter;
        if (payload.month !== undefined) {
            month_filter = payload.month;
        }

        let city_filter = state.city_filter;
        if (payload.city !== undefined) {
            city_filter = payload.city;
        }

        if (month_filter != null) {
            filteredPackages = [];
            for (let i = 0, l = packages.length; i < l; ++i) {
                if (new Date(packages[i].month).getTime() !==
                    month_filter.getTime()) {
                    continue;
                }

                filteredPackages.push(packages[i]);
            }

            packages = filteredPackages;
        }

        if (city_filter != null) {
            filteredPackages = [];
            for (let i = 0, l = packages.length, clonedMonth; i < l; ++i) {
                clonedMonth = clone_package_month(packages[i], false);
                clonedMonth.data = [];
                for (let x = 0, ll = packages[i].data.length, pkg, foundCity; x <
                ll; ++x) {
                    pkg = packages[i].data[x];
                    if (pkg.venue == null || pkg.venue.cities == null) {
                        continue;
                    }

                    foundCity = false;

                    for (let y = 0, lll = pkg.venue.cities.length; y <
                    lll; ++y) {
                        if (pkg.venue.cities[y].id === city_filter) {
                            foundCity = true;
                            break;
                        }
                    }

                    if (foundCity) {
                        clonedMonth.data.push(pkg);
                    }
                }

                if (clonedMonth.data.length > 0) {
                    filteredPackages.push(clonedMonth);
                }
            }

            packages = filteredPackages;
        }

        return Object.assign({}, state, {
            packages_by_month: packages,
            month_filter: month_filter,
            city_filter: city_filter,
            show_empty_dates: show_empty_dates,
        });
    },
});
